
export type Retweet200 = {
  code?: string;
  message?: string;
  success?: boolean;
};
